<template>
  <div class="qa">
    <h2>よくある質問</h2>
    <div class="container">
      <h3>ぴたコインとは</h3>
      <p>
        ビットコインの価格予想に参加して報酬をゲットしましょう。「基準価格」から30分後のビットコイン価格が「上がる」か「下がる」かを予想してください。投票は、新たな基準価格が設定される10分前に締め切られます(例: 8時50分, 16時20分)<br>
        現在、1回の投票につき「2 Satoshi」(電話番号で登録した場合は10 Satoshi)を手に入れることができ、出金は「3000 Satoshi + 手数料」から可能です。
      </p>
      <h3>基準価格とは</h3>
      <p>
        「基準価格」は予想の開始時刻でのビットコインの価格(円/BTC)です。毎時00分と30分の価格が設定されます(例: 9時00分, 16時30分)
      </p>
      <h3>現在価格とは</h3>
      <p>
        「現在価格」は現在時刻時点でのビットコインの価格(円/BTC)です。国内の取引所各社の価格から算出されています。
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QA',
  components: {
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .qa{
    padding-top: 100px;
    background: #fff;
    margin: 0;
    margin-top: 60px;
  }
  h2{
    font-weight: bold;
    font-size: 40px;
    color: #333;
    line-height: 1;
    margin: 0;
    text-align: center;
  }
  h3{
    text-align: left;
    font-weight: bold;
    font-size: 28px;
    color: #333;
    margin-top: 0;
    margin-bottom: 25px;
  }
  p{
    margin-top: 0;
    text-align: left;
    margin-bottom: 40px;
  }
  @media all and (max-width: 740px) {
    .qa{
      padding-top: 50px;
    }
    h2{
      font-size: 24px;
      text-align: center;
    }
    h3{
      font-size: 20px;
      margin-bottom: 5px;
      text-align: center;
    }
    p{
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/QA.vue